import React from "react";

const CurrentBannedBtn = ({ state }) => {
  const statesArray = [
    {
      state: false,
      text: "آزاد",
      className: "px-[10px] py-1 rounded-md text-success-60 bg-success-10 text-title-sm-regular",
    },
    {
      state: true,
      text: "مسدود",
      className: "text-error-90 bg-error-10 px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
  ];

  const activeItem = statesArray.find((item) => item.state === state);

  return <div className={activeItem.className}>{activeItem.text}</div>;
};

export default CurrentBannedBtn;
